<script setup lang="ts">
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const darkMode = defineModel<boolean>({ default: true });
</script>
<template>
    <div>
        <p class="mt-4 text-lg font-medium">
            {{ $t("appearances.default_theme") }}
        </p>

        <div class="mt-2 flex items-center space-x-2">
            <Switch id="dark-mode" v-model:checked="darkMode" />
            <Label for="dark-mode">Dark mode</Label>
        </div>
    </div>
</template>
